import Tooltip from '../../components/common/Tooltip'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { useFirestoreGeneralOrderBy, useFirestoreUsers } from '../../firebase/useFirestore'
import ExportBar from '../../components/common/ExportBar'
import buildNotesExportRows, { NOTES_EXPORT_HEADER } from '../../helpers/export/buildNotesExportRows'
import downloadDatedExport from '../../helpers/export/downloadDatedExport'
import filterExportRows from '../../helpers/export/filterExportRows'
import getSubmitterName from '../../helpers/getSubmitterName'
import NoteBodyCell from '../../components/notes/NoteBodyCell'
import { db, timestamp } from '../../firebase/config'
import { v4 as uuid } from 'uuid'
import { client } from '../../hooks/Client'
import { SavedIcon } from "../../StateManagment/SavedIcon";
import Location from "../../hooks/Location"
import { useContext, useState, useEffect } from "react";
import useSettings from "../../hooks/Settings";
import settingsIcon from "../../images/icons/settings-icon.png";
import { useHistory } from "react-router-dom";
import { Auth } from '../../StateManagment/Auth'
import UserImageMeta from '../../components/user/UserImageMeta'
import UserNameMeta from '../../components/user/UserNameMeta'
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import DeleteModal from "../../components/common/DeleteModal";
import softDeleteDoc from "../../helpers/softDeleteDoc";
import Table from '../../components/common/table/Table.jsx';
import TableCell from '../../components/common/table/TableCell.jsx';
import TableTitleCell from '../../components/common/table/TableTitleCell.jsx';
import ReadOnlyGuard from '../../components/common/ReadOnlyGuard';

const Reports = ({personaNavigation}) => {
   // Context
   const [saved, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)

    // State
    const [dragArray, setDragArray] = useState([]);
    const [exportMessage, setExportMessage] = useState('')
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteName, setDeleteName] = useState('dit rapport')
    const [deleteDocid, setDeleteDocid] = useState('')


   // Hooks
   const personaId = Location()[3]
   const history = useHistory()
   const options = { year: 'numeric', month: 'numeric', day: 'numeric' };

   // Firestore
   const users = useFirestoreUsers()
   const reports = useFirestoreGeneralOrderBy('PersonaReports', 'PersonaID', personaId ? personaId : '', 'Position', 'desc')

   // Whenever Firestore data changes, update dragArray state
    useEffect(() => {
        setDragArray(reports);
    }, [reports]);

    // DRAG & DROP: reorder items and update Firestore
    const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(dragArray);
    const [movedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, movedItem);

    // Update local state to reflect the reorder immediately
    setDragArray(items);

    // Now update Firestore with new positions
    items.forEach((dragArray, idx) => {
        db.collection('PersonaReports')
        .doc(dragArray.docid) // assuming .docid is stored for each doc
        .update({ Position: idx + 1 });
    });

    // Show "saved" icon
        setSaved('flex');
    };

    // Add new report
   const addReport = async () => {

    const reportId = uuid()
    const position = reports.length + 1

       await db.collection('PersonaReports')
       .add({
           ID: reportId,
           PersonaID: personaId,
           Title: 'Nieuwe notitie' + ' ' + position,
           Description: '',
           Tags: [],
           CompagnyID: client,
           Compagny: client,
           Position: position,
           Timestamp: timestamp,
           User: auth.ID,
           Body: '',
       })   

   }

   // Delete modal 
   const deleteModalHandler = (e) => {
    const docid = e.currentTarget.dataset.docid
    const deleteName = e.currentTarget.dataset.deletename

    setDeleteDocid(docid)
    setDeleteName(deleteName)

    setDeleteModal(!deleteModal)
}

    // Export — het venster kiest wát er mee moet, dit bouwt de rijen.
   const exportHandler = (selection) => {
       const rows = filterExportRows(reports, selection, {
           getId: (report) => report.docid,
           getDate: (report) => (report?.Timestamp?.toDate ? report.Timestamp.toDate() : null),
       })

       const written = downloadDatedExport(
           buildNotesExportRows(rows, { getAuthor: (id) => getSubmitterName(id, users) }),
           { prefix: 'Notities', format: selection.format, header: NOTES_EXPORT_HEADER }
       )

       if (!written) setExportMessage('Geen notities gevonden voor deze keuze.')
       else setExportMessage('')
   }

    // Delete report — zacht verwijderen (ADR-008), zodat een misklik
    // terug te halen is.
   const deleteReport = async () => {

       await softDeleteDoc({ collection: 'PersonaReports', docid: deleteDocid, authId: auth?.ID })

       setSaved('flex')

   }

 return (
   <div style={{display: personaNavigation === 'report' ? 'block' : 'none'}}>
       <div  className="persona-option-container">
           <div className='table-container'>
                <ReadOnlyGuard edit="personas.edit">
                    {(canEdit) => (
                        <Table
                            columns={[
                                { key: 'drag', label: '', searchable: false },
                                { key: 'title', label: 'TITEL' },
                                { key: 'date', label: 'DATUM', searchable: false },
                                { key: 'author', label: 'AUTEUR', searchable: false },
                                { key: 'body', label: 'INHOUD', searchable: false },
                                { key: 'delete', label: 'VERWIJDEREN', searchable: false },
                            ]}
                            items={dragArray || []}
                            getItemKey={(report) => report.ID}
                            renderRow={(report) => (
                                <>
                                    <TableCell>
                                        <DragIndicatorOutlinedIcon />
                                    </TableCell>
                                    <TableTitleCell
                                        value={report.Title}
                                        to={`/${client}/personareportdetail/${personaId}/${report.ID}`}
                                        readOnly
                                    />
                                    <TableCell>
                                        {report.Timestamp.toDate().toLocaleDateString("nl-NL", options)}
                                    </TableCell>
                                    <TableCell>
                                        <div id='report-user-meta-container'>
                                            <UserImageMeta userID={report.User} />
                                            <UserNameMeta userID={report.User} />
                                        </div>
                                    </TableCell>
                                    <TableCell>
                                        <NoteBodyCell body={report.Body} />
                                    </TableCell>
                                    <TableCell>
                                        {canEdit && (
                                            <Tooltip content={'Notitie verwijderen'} top='-60px' width={'30px'}>
                                                <DeleteOutlinedIcon className='table-delete-icon' data-id={report.ID} data-docid={report.docid} data-deletename={report.Title} onClick={deleteModalHandler} />
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </>
                            )}
                            searchAccessor={(report) => report?.Title || ''}
                            searchPlaceholder="Zoeken op titel"
                            emptyMessage="Geen rapporten gevonden."
                            draggable
                            droppableId="reports"
                            onDragEnd={handleDragEnd}
                            addRow={canEdit ? {
                                toolTipContent: 'Notitie toevoegen',
                                onClick: addReport,
                            } : undefined}
                        />
                    )}
                </ReadOnlyGuard>
                <ExportBar
                    pageHeader='Notities exporteren'
                    itemsLabel='Notities'
                    items={(reports || []).map((report) => ({ id: report.docid, label: report.Title || '(geen titel)' }))}
                    onExport={exportHandler}
                    emptyMessage='Geen notities gevonden.'
                />
                {exportMessage && <p className='dashboard-export-message' role='alert'>{exportMessage}</p>}
                <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteItem={deleteReport} deleteName={deleteName} softDelete />
           </div>
       </div>
   </div>
 )
}

export default Reports
